export default __webpack_public_path__ + "static/media/screen-recording.d7a4ac0e.webp";